import { createContext } from 'react'

export interface WebSocketContextType {
  isConnected: boolean
  connectionState: 'connecting' | 'connected' | 'disconnected' | 'error'
  subscribe: (callback: (conversationId?: string, message?: unknown, eventType?: string) => void) => () => void
  connect: () => void
  disconnect: () => void
}

export const WebSocketContext = createContext<WebSocketContextType | null>(null)
